import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { DialogManager, RouteGuard, CommandContribution, CommandRegistry, CommandService } from '@patsnap/tahiti-core';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { PatentDbService } from './services/patent/patent-db-service';
import { PatentDbServiceImpl } from './services/patent/impls/patent-db-service-impl';
import { PatentDbApi } from './apis/patent-db-api';
import { PatentApiImpl } from './apis/impls/patent-api-impl';
import { CompanyService } from './services/company-service';
import { CompanyServiceImpl } from './services/impls/company-service';
import { GetCompanyTreeApi } from './apis/company-tree-api';
import { GetCompanyNameApi } from './apis/company-name-api';
import { CompanyTreeApiImpl } from './apis/impls/company-api';
import { LanguageApi } from './apis/language-api';
import { LanguageApiImpl } from './apis/impls/language-api-impl';
import { VueAutoMountManager } from './services/auto-mount/impls/vue-auto-mount-manager';
import { AutoMountModel } from './services/auto-mount/auto-mount-manager';
import { AutoMountModelImpl } from './services/auto-mount/impls/auto-mount-model';
import router from '@/routers';

export const commonContainer = new ContainerModule((bind) => {
    // 绑定命令服务 (用于 createDialog 和命令模式)
    bind(CommandRegistry).toSelf();
    bind(CommandService).toDynamicValue(context => context.container.get(CommandRegistry));
    bindContributionProvider(bind, CommandContribution);

    // 绑定 Dialog Manager (用于 createDialog)
    bind(DialogManager).to(VueAutoMountManager);
    bind(RouteGuard).toConstantValue(router);
    bind(AutoMountModel).to(AutoMountModelImpl);

    // 绑定 Patent API
    bind(PatentDbApi).to(PatentApiImpl);

    // 绑定 Patent Service
    bind(PatentDbService).to(PatentDbServiceImpl);

    // 绑定 Company APIs
    bind(GetCompanyTreeApi).to(CompanyTreeApiImpl);
    bind(GetCompanyNameApi).to(CompanyTreeApiImpl);

    // 绑定 Company Service
    bind(CompanyService).to(CompanyServiceImpl);

    // 绑定 Language API
    bind(LanguageApi).to(LanguageApiImpl);
});
